import { space } from "shared/styles/constants";
import styled, { css } from "styled-components";

interface Props {
  isDisabled?: boolean;
}

export const StyledAccommodationRoomTypeSelectOption = styled.span<Props>`
  && {
    &--is-disabled {
      cursor: not-allowed;
    }
  }

  ${({ isDisabled }) =>
    isDisabled &&
    css`
      opacity: 0.5;
      cursor: not-allowed;
      pointer-events: none;
    `}

  padding: ${space.xs};
  width: fit-content;
  display: inline-block !important;
`;
